import { IBoondock, IBoondockRating, ICaretaker, IGuestRating, IListingRating, IPoiRating } from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export enum RatingActionTypes {
  LoadGuestRatings = '[Rating] Load Ratings for a Guest',
  LoadListingRatings = '[Rating] Load Ratings for a Listing',
  LoadBoondockRatings = '[Rating] Load Ratings for a Boondock Listing',
  LoadPoiRatings = '[Rating] Load Ratings for a POI',
  RatingLoadError = '[Rating] Rating Load Error',
  ListingRatingsLoaded = '[Rating] Listing Ratings Loaded',
  GuestRatingsLoaded = '[Rating] Guest Ratings Loaded',
  BoondockRatingsLoaded = '[Rating] Boondock Ratings Loaded',
  PoiRatingsLoaded = '[Rating] Poi Ratings Loaded',
  CreateListingRatings = '[Rating] Create Listing Ratings',
  ListingRatingsCreated = '[Rating] Listing Ratings Created',
  ListingRatingsCreateFailed = '[Rating] Listing Ratings Create Failed',
  SyncListingRatings = '[Rating] Sync Listing Ratings',
  CreateGuestRatings = '[Rating] Create Guest Ratings',
  GuestRatingsCreated = '[Rating] Guest Ratings Created',
  SyncGuestRatings = '[Rating] Sync Guest Ratings',
  CreateBoondockRatings = '[Rating] Create Boondock Ratings',
  BoondockRatingsCreated = '[Rating] Boondock Ratings Created',
  CreatePoiRatings = '[Rating] Create POI Ratings',
  PoiRatingsCreated = '[Rating] POI Ratings Created',
  SelectCaretakerListing = '[Rating] Select Caretaker Listing',
  SelectCaretakerListingComplete = '[Rating] Select Caretaker Listing Complete',
  SelectCaretakerListingFailed = '[Rating] Select Caretaker Listing Failed',
}

export const loadGuestRatings = createAction(
  RatingActionTypes.LoadGuestRatings,
  props<{ guestId: number; }>(),
);

export const loadListingRatings = createAction(
  RatingActionTypes.LoadListingRatings,
  props<{ listingId: number }>(),
);

export const loadBoondockRatings = createAction(
  RatingActionTypes.LoadBoondockRatings,
  props<{ boondockId: number; }>(),
);

export const loadPoiRatings = createAction(
  RatingActionTypes.LoadPoiRatings,
  props<{ poiId: number; }>(),
);

export const ratingLoadError = createAction(
  RatingActionTypes.RatingLoadError,
  props<{ error: any; }>(),
);

export const listingRatingsLoaded = createAction(
  RatingActionTypes.ListingRatingsLoaded,
  props<{ ratings: IListingRating[]; }>(),
);

export const guestRatingsLoaded = createAction(
  RatingActionTypes.GuestRatingsLoaded,
  props<{ ratings: IGuestRating[]; }>(),
);

export const boondockRatingsLoaded = createAction(
  RatingActionTypes.BoondockRatingsLoaded,
  props<{ ratings: IBoondockRating[]; }>(),
);

export const poiRatingsLoaded = createAction(
  RatingActionTypes.PoiRatingsLoaded,
  props<{ ratings: IPoiRating[]; }>(),
);

export const createListingRatings = createAction(
  RatingActionTypes.CreateListingRatings,
  props<{ ratings: IListingRating[]; }>(),
);

export const listingRatingsCreated = createAction(
  RatingActionTypes.ListingRatingsCreated,
  props<{ ratings: IListingRating[]; }>(),
);

export const listingRatingsFailed = createAction(
  RatingActionTypes.ListingRatingsCreateFailed,
  props<{ error: any; }>(),
);

export const syncListingRatings = createAction(
  RatingActionTypes.SyncListingRatings,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ response?: IListingRating[]; request?: IListingRating[]; error?: any; }>(),
);

export const createGuestRatings = createAction(
  RatingActionTypes.CreateGuestRatings,
  props<{ ratings: IGuestRating[]; }>(),
);

export const guestRatingsCreated = createAction(
  RatingActionTypes.GuestRatingsCreated,
);

export const syncGuestRatings = createAction(
  RatingActionTypes.SyncGuestRatings,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ response?: IGuestRating[]; request?: IGuestRating[]; error?: any; }>(),
);

export const createBoondockRatings = createAction(
  RatingActionTypes.CreateBoondockRatings,
  props<{ ratings: IBoondockRating[]; }>(),
);

export const boondockRatingsCreated = createAction(
  RatingActionTypes.BoondockRatingsCreated,
);

export const createPoiRatings = createAction(
  RatingActionTypes.CreatePoiRatings,
  props<{ ratings: IPoiRating[]; }>(),
);

export const poiRatingsCreated = createAction(
  RatingActionTypes.PoiRatingsCreated,
);

export const selectCaretakerBoondock = createAction(
  RatingActionTypes.SelectCaretakerListing,
  props<{ caretaker: ICaretaker; }>(),
);

export const selectCaretakerBoondockComplete = createAction(
  RatingActionTypes.SelectCaretakerListingComplete,
  props<{ boondock: IBoondock; }>(),
);

export const selectCaretakerBoondockFailed = createAction(
  RatingActionTypes.SelectCaretakerListingFailed,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any; }>(),
);
